import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import { Button, TextField, MenuItem } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import DownloadIcon from '@mui/icons-material/Download';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
    marginBottom: theme.spacing(2)
  },
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1)
  },
  spacer: {
    flexGrow: 1
  },
  searchButton: {
    marginLeft: theme.spacing(1)
  },
  yearSelect: {
    minWidth: 120
  }
}));

const RisksToolbar = props => {
  const { className, onSearch, year, onYearChange, onDownload, ...rest } = props;
  const classes = useStyles();
  
  // Generate year options (current year and past 5 years)
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 6 }, (_, i) => currentYear - i);

  const handleSearchClick = () => {
    if (onSearch) {
      onSearch();
    }
  };

  const handleYearChange = (event) => {
    if (onYearChange) {
      onYearChange(event.target.value);
    }
  };

  const handleDownloadClick = () => {
    if (onDownload) {
      onDownload();
    }
  };

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <TextField
        select
        label="Year"
        value={year || currentYear}
        onChange={handleYearChange}
        variant="outlined"
        size="small"
        className={classes.yearSelect}
      >
        {years.map((y) => (
          <MenuItem key={y} value={y}>
            {y}
          </MenuItem>
        ))}
      </TextField>
      
      <Button
        color="primary"
        variant="contained"
        onClick={handleSearchClick}
        startIcon={<SearchIcon />}
        className={classes.searchButton}
      >
        Search
      </Button>
      
      <Button
        color="secondary"
        variant="outlined"
        onClick={handleDownloadClick}
        startIcon={<DownloadIcon />}
      >
        Download CSV
      </Button>
    </div>
  );
};

RisksToolbar.propTypes = {
  className: PropTypes.string,
  onSearch: PropTypes.func,
  year: PropTypes.number,
  onYearChange: PropTypes.func,
  onDownload: PropTypes.func
};

export default RisksToolbar;
